import { render, staticRenderFns } from "./swTopDeals.vue?vue&type=template&id=aeefb696&scoped=true"
import script from "./swTopDeals.vue?vue&type=script&lang=js"
export * from "./swTopDeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeefb696",
  null
  
)

export default component.exports